import { Card, colors, Divider, Grid, Typography } from "@mui/material";
import CardRecCatIdade from "./CardRecCatIdade";

import { IEventoResponse } from "interfaces/eventos";
import MDBox from "components/MDBox";
import { totalsType } from "..";
import { formatCurrency } from "helpers/utils";
import TaxasBancarias from "./TaxasBancarias";

interface Props {
  evento: IEventoResponse;
  totals: totalsType;
}

export default function RecebimentosPorCategoriaIdade({
  totals,
  evento,
}: Props) {
  if (!evento || !totals) return;

  const valorTaxaInscricao = evento.taxaInscricao;
  const TOTAL_TAXAS_BANCARIAS =
    totals.taxaBancaria.pix.total +
    totals.taxaBancaria.cartao.total +
    totals.taxaBancaria.boleto.total;
  const saldoFinal =
    Number(totals.totalArrecadado.valor) +
    Number(evento.valorServico) -
    TOTAL_TAXAS_BANCARIAS;

  return (
    <>
      <MDBox display="flex" justifyContent="center" flexWrap="wrap" gap={1}>
        {totals.categorias.map((cat, idx) => (
          <CardRecCatIdade
            key={idx}
            categoria={cat.categoria}
            inscritos={cat.qtd}
            valor={cat.totalInsc}
          />
        ))}
      </MDBox>

      {/* RESUMO GERAL */}
      <Card
        sx={{
          display: "flex",
          py: 2,
          px: { xs: 2, sm: 4 },
          mt: 2,
        }}
      >
        <Typography variant="h4" fontWeight="bold" color="dark">
          Resumo geral
        </Typography>

        <Divider />
        <Grid container spacing={1}>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              width={{ xs: "100%", md: "75%" }}
            >
              <Typography variant="body2">🔹Total de inscrições:</Typography>
              <Typography
                variant="body1"
                fontWeight="bold"
                color={colors.blue[500]}
              >
                {totals.totalGeralInscricoes.qtd}
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              width={{ xs: "100%", md: "75%" }}
            >
              <Typography variant="body2">
                🔹Total de inscrições pagas:
              </Typography>
              <Typography
                variant="body1"
                fontWeight="bold"
                color={colors.green[500]}
              >
                {totals.totalArrecadado.qtd}
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              width={{ xs: "100%", md: "75%" }}
            >
              <Typography variant="body2">
                🔹Total de inscrições canceladas:
              </Typography>
              <Typography
                variant="body1"
                fontWeight="bold"
                color={colors.red[500]}
              >
                {totals.totalCancelado.qtd}
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              width={{ xs: "100%", md: "75%" }}
            >
              <Typography variant="body2">
                🔹Número de atletas inscritos:
              </Typography>

              <MDBox
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap={1}
              >
                <Typography variant="caption" color={colors.blue[500]}>
                  Cortesias: ({totals.totalParticipantesCortesia.qtd})
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  color={colors.green[500]}
                >
                  {totals.totalParticipantes.qtd}
                </Typography>
              </MDBox>
            </MDBox>
          </Grid>

          {/* próxima linha */}

          <Grid item xs={12} md={6} lg={6}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              width={{ xs: "100%", md: "75%" }}
            >
              <Typography variant="body2">
                🔹Total de inscrições pendentes:
              </Typography>
              <Typography
                variant="body1"
                fontWeight="bold"
                color={colors.amber[600]}
              >
                {totals.totalValorPendentes.qtd}
              </Typography>
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              width={{ xs: "100%", md: "75%" }}
            >
              <Typography variant="body2">
                🔹Número de participantes pendentes:
              </Typography>
              <Typography
                variant="body1"
                fontWeight="bold"
                color={colors.amber[600]}
              >
                {totals.totalParticipantesPendentes.qtd}
              </Typography>
            </MDBox>
          </Grid>
        </Grid>

        <Divider />

        <Grid container spacing={1}>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              width={{ xs: "100%", md: "75%" }}
            >
              <MDBox>
                <Typography variant="body2">🔹Taxa administrativa: </Typography>
                <Typography variant="body2" sx={{ fontWeight: "bold", ml: 3 }}>
                  {formatCurrency(valorTaxaInscricao)}{" "}
                  <Typography variant="caption">(-) cortesia</Typography>
                </Typography>
              </MDBox>
              <Typography variant="body1" fontWeight="bold">
                {formatCurrency(totals.totalTaxaAdministrativa.valor)}
              </Typography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              width={{ xs: "100%", md: "75%" }}
            >
              <Typography variant="body2">🔹Valor serviço:</Typography>
              <Typography variant="body1" fontWeight="bold">
                {formatCurrency(evento.valorServico)}
              </Typography>
            </MDBox>
            <MDBox
              display="flex"
              justifyContent="space-between"
              width={{ xs: "100%", md: "75%" }}
            >
              <Typography variant="body2">🔹Valor arrecadado:</Typography>
              <Typography variant="body1" fontWeight="bold">
                {formatCurrency(totals.totalArrecadado.valor)}
              </Typography>
            </MDBox>
            <MDBox
              display="flex"
              justifyContent="space-between"
              width={{ xs: "100%", md: "75%" }}
            >
              <Typography variant="body2">
                🔹Valor inscrições canceladas:
              </Typography>
              <Typography variant="body1" fontWeight="bold">
                {formatCurrency(totals.totalCancelado.valor)}
              </Typography>
            </MDBox>
          </Grid>
        </Grid>

        <TaxasBancarias totals={totals} />

        <Divider />

        <MDBox px={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={7} lg={7}>
              <Typography variant="h6" fontWeight="bold">
                Taxas bancárias
              </Typography>
              <Typography variant="subtitle1" fontWeight="bold">
                Saldo final
              </Typography>
              <Typography
                variant="subtitle2"
                color={colors.grey[500]}
                sx={{ fontStyle: "italic" }}
              >
                (total arrecadado + valor do serviço - taxas bancárias)
              </Typography>
            </Grid>
            <Grid item xs={12} md={5} lg={5} sx={{ textAlign: "right" }}>
              <Typography
                variant="h6"
                fontWeight="bold"
                color={colors.red[500]}
              >
                (-) {formatCurrency(TOTAL_TAXAS_BANCARIAS)}
              </Typography>
              <Typography variant="h3" fontWeight="bold">
                {formatCurrency(saldoFinal)}
              </Typography>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </>
  );
}
